// import React, { useEffect, useState, useRef } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   exportOrders,
//   fetchOrders,
//   updateOrderStatus,
// } from "../../features/order/ordersSlice";
// import html2canvas from "html2canvas";

// function DashboardOrders() {
//   const dispatch = useDispatch();
//   const {
//     items: orders,
//     loading,
//     statusOptions,
//   } = useSelector((state) => state.orders);

//   console.log("Orders:", orders);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [filters, setFilters] = useState({
//     start_date: "",
//     end_date: "",
//     status: "",
//     order_number: "",
//   });

//   const invoiceRef = useRef(null);

//   useEffect(() => {
//     dispatch(fetchOrders());
//   }, [dispatch]);

//   const handleStatusChange = (id, newStatus) => {
//     if (!Object.keys(statusOptions).includes(newStatus)) {
//       alert("الحالة غير صالحة");
//       return;
//     }
//     dispatch(updateOrderStatus({ id, status: newStatus }));
//   };

//   const handleExport = async () => {
//     try {
//       const url = await dispatch(exportOrders(filters)).unwrap();
//       if (url) {
//         const link = document.createElement("a");
//         link.href = url;
//         link.download = "";
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//       }
//     } catch (error) {
//       console.error("Export failed:", error);
//     }
//   };

//   const handleFilterChange = (e) => {
//     setFilters({
//       ...filters,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const getStatusClass = (status) => {
//     const classes = {
//       pending: "table-warning",
//       processing: "table-info",
//       shipped: "table-primary",
//       delivered: "table-success",
//       cancelled: "table-danger",
//     };
//     return classes[status] || "";
//   };

//   const handleDownloadImage = () => {
//     html2canvas(invoiceRef.current).then((canvas) => {
//       const link = document.createElement("a");
//       link.download = `invoice-${selectedOrder.order_number}.png`;
//       link.href = canvas.toDataURL();
//       link.click();
//     });
//   };

//   const handlePrintInvoice = () => {
//     const content = invoiceRef.current;
//     const printWindow = window.open("", "_blank");
//     printWindow.document.write(
//       "<html><head><title>فاتورة</title></head><body>",
//     );
//     printWindow.document.write(content.outerHTML);
//     printWindow.document.write("</body></html>");
//     printWindow.document.close();
//     printWindow.print();
//   };

//   if (loading) return <div className="text-center mt-5">جار التحميل...</div>;

//   return (
//     <div className="container mt-2">
//       {/* Filter Section */}
//       <div className="card mb-4">
//         <div className="card-body">
//           <div className="row g-3 align-items-end">
//             <div className="col-md-3">
//               <label className="form-label">تاريخ البداية</label>
//               <input
//                 type="date"
//                 className="form-control"
//                 name="start_date"
//                 value={filters.start_date}
//                 onChange={handleFilterChange}
//               />
//             </div>

//             <div className="col-md-3">
//               <label className="form-label">تاريخ النهاية</label>
//               <input
//                 type="date"
//                 className="form-control"
//                 name="end_date"
//                 value={filters.end_date}
//                 onChange={handleFilterChange}
//               />
//             </div>

//             <div className="col-md-3">
//               <label className="form-label">الحالة</label>
//               <select
//                 className="form-select"
//                 name="status"
//                 value={filters.status}
//                 onChange={handleFilterChange}
//               >
//                 <option value="">الكل</option>
//                 {Object.entries(statusOptions).map(([value, label]) => (
//                   <option key={value} value={value}>
//                     {label}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="col-md-3">
//               <label className="form-label">بحث برقم الأوردر</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 placeholder="رقم الأوردر"
//                 name="order_number"
//                 value={filters.order_number}
//                 onChange={handleFilterChange}
//               />
//             </div>
//           </div>

//           <div className="row mt-3">
//             <div className="col-lg-3 col-md-6 ms-auto ">
//               <button
//                 onClick={handleExport}
//                 className="btn btn-success w-100 d-flex align-items-center justify-content-center gap-2"
//               >
//                 <i className="fa-solid fa-arrow-up"></i>
//                 <span> إستخراج الطلبات</span>
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Orders Table */}
//       <div className="card">
//         <div className="card-header bg-dark text-white d-flex justify-content-between">
//           <h4 className="mb-0">قائمة الطلبات</h4>
//           <span className="badge fs-6 bg-light text-dark">
//             {orders.length} طلب
//           </span>
//         </div>
//         <div className="card-body">
//           <div className="table-responsive">
//             <table className="table table-bordered table-hover text-center align-middle">
//               <thead className="table-dark">
//                 <tr>
//                   <th>رقم الأوردر</th>
//                   <th>الاسم</th>
//                   <th>رقم الهاتف</th>
//                   <th>رقم الواتس</th>
//                   <th>الإجمالي</th>
//                   <th>سعر الشحن</th>
//                   <th>العنوان</th>
//                   <th>الحالة</th>
//                   <th>الفاتورة</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {orders
//                   .filter((order) =>
//                     filters.order_number
//                       ? order.order_number
//                           .toString()
//                           .includes(filters.order_number.toString())
//                       : true,
//                   )
//                   .map((order) => (
//                     <tr key={order.id} className={getStatusClass(order.status)}>
//                       <td>{order.order_number}</td>
//                       <td>{order.name}</td>
//                       <td>{order.address?.phone}</td>
//                       <td>{order.phone}</td>
//                       <td>{order.total_price} ج.م</td>
//                       <td>{order.shipping_price} ج.م</td>
//                       <td
//                         style={{
//                           maxWidth: "250px",
//                         }}
//                         title={order.address?.address}
//                       >
//                         {order.address?.address
//                           ? order.address.address.length > 60
//                             ? `${order.address.address.slice(0, 10)}...`
//                             : order.address.address
//                           : "غير محدد"}
//                       </td>
//                       <td>
//                         <div
//                           className="position-relative"
//                           style={{ minWidth: "120px" }}
//                         >
//                           <select
//                             className="form-select bg-white text-dark border-dark w-100 py-1 text-center"
//                             value={order.status}
//                             onChange={(e) =>
//                               handleStatusChange(order.id, e.target.value)
//                             }
//                           >
//                             {Object.entries(statusOptions).map(
//                               ([value, label]) => (
//                                 <option key={value} value={value}>
//                                   {label}
//                                 </option>
//                               ),
//                             )}
//                           </select>
//                         </div>
//                       </td>
//                       <td>
//                         <button
//                           className="btn btn-outline-info border-0 p-0"
//                           onClick={() => setSelectedOrder(order)}
//                           title="عرض الفاتورة"
//                         >
//                           <i className="fas fa-file-invoice fs-4"></i>
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>

//       {/* Invoice Modal */}
//       {selectedOrder && (
//         <div
//           className="modal fade show"
//           style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.76)" }}
//           tabIndex="-1"
//         >
//           <div className="modal-dialog modal-lg">
//             <div className="modal-content">
//               <div className="modal-header bg-info text-dark">
//                 <h5 className="modal-title">
//                   فاتورة الطلب #{selectedOrder.order_number}
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close btn-close-dark mx-4"
//                   onClick={() => setSelectedOrder(null)}
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 <div ref={invoiceRef} className="p-4 border rounded">
//                   <div className="text-center mb-4">
//                     <h3 className="fs-1 fw-bold">فاتورة طلب</h3>
//                   </div>

//                   <div className="row mb-4">
//                     <div className="col-md-6">
//                       <h5>معلومات العميل</h5>
//                       <p>
//                         <strong>الاسم:</strong> {selectedOrder.name}
//                       </p>
//                       <p>
//                         <strong>رقم الهاتف:</strong> {selectedOrder.phone}
//                       </p>
//                       <p>
//                         <strong>رقم الواتس:</strong>{" "}
//                         {selectedOrder.address?.phone}
//                       </p>
//                       <p>
//                         <strong>العنوان:</strong>{" "}
//                         {selectedOrder.address?.address || "غير محدد"}
//                       </p>
//                       <p>
//                         <strong>رقم الطلب:</strong> {selectedOrder.order_number}
//                       </p>
//                     </div>
//                     <div className="col-md-6">
//                       <img
//                         src="/images/nabtah.png"
//                         className="w-75"
//                         alt="logo"
//                       />
//                     </div>
//                   </div>

//                   <div className="table-responsive mb-4 text-center">
//                     <table className="table table-bordered">
//                       <thead className="table-light">
//                         <tr>
//                           <th>#</th>
//                           <th>المنتج</th>
//                           <th>الكمية</th>
//                           <th>السعر</th>
//                           <th>المجموع</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {selectedOrder.order_items?.map((item, index) => (
//                           <tr key={item.id}>
//                             <td>{index + 1}</td>
//                             <td>{item.product_name || "غير محدد"}</td>
//                             <td>{item.quantity}</td>
//                             <td>{item.price} ج.م</td>
//                             <td>{item.price * item.quantity} ج.م</td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>

//                   <div className="row justify-content-end">
//                     <div className="col-12">
//                       <table className="table table-bordered">
//                         <tbody>
//                           <tr>
//                             <th>المجموع الجزئي</th>
//                             <td>{selectedOrder.subtotal} ج.م</td>
//                           </tr>
//                           <tr>
//                             <th>سعر الشحن</th>
//                             <td>{selectedOrder.shipping_price} ج.م</td>
//                           </tr>
//                           <tr className="table-active">
//                             <th>الإجمالي</th>
//                             <td>{selectedOrder.total_price} ج.م</td>
//                           </tr>
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="modal-footer mx-auto">
//                 <button
//                   className="btn btn-primary me-2"
//                   onClick={handleDownloadImage}
//                 >
//                   <i className="fas fa-download mx-2"></i>تحميل كصورة
//                 </button>
//                 <button
//                   className="btn btn-success mx-2"
//                   onClick={handlePrintInvoice}
//                 >
//                   <i className="fas fa-print mx-2"></i>طباعة
//                 </button>
//                 <button
//                   className="btn btn-secondary"
//                   onClick={() => setSelectedOrder(null)}
//                 >
//                   <i className="fas fa-times mx-2"></i>إغلاق
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default DashboardOrders;
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  exportOrders,
  fetchOrders,
  updateOrderStatus,
} from "../../features/order/ordersSlice";
import html2canvas from "html2canvas";

function DashboardOrders() {
  const dispatch = useDispatch();

  const {
    items: orders,
    loading,
    statusOptions,
  } = useSelector((state) => state.orders);

  const [selectedOrder, setSelectedOrder] = useState(null);

  const [filters, setFilters] = useState({
    start_date: "",
    end_date: "",
    status: "",
    order_number: "",
  });

  const invoiceRef = useRef(null);

  useEffect(() => {
    dispatch(fetchOrders());
  }, [dispatch]);

  const handleStatusChange = (id, newStatus) => {
    if (!Object.keys(statusOptions).includes(newStatus)) {
      alert("الحالة غير صالحة");
      return;
    }

    dispatch(updateOrderStatus({ id, status: newStatus }));
  };

  const handleExport = async () => {
    try {
      const url = await dispatch(exportOrders(filters)).unwrap();

      if (url) {
        const link = document.createElement("a");

        link.href = url;
        link.download = "";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.error("Export failed:", error);
    }
  };

  const handleFilterChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value,
    });
  };

  const getStatusClass = (status) => {
    const classes = {
      pending: "table-warning",
      processing: "table-info",
      shipped: "table-primary",
      delivered: "table-success",
      cancelled: "table-danger",
    };

    return classes[status] || "";
  };

  const handleDownloadImage = () => {
    html2canvas(invoiceRef.current).then((canvas) => {
      const link = document.createElement("a");

      link.download = `invoice-${selectedOrder.order_number}.png`;
      link.href = canvas.toDataURL();

      link.click();
    });
  };

  const handlePrintInvoice = () => {
    const content = invoiceRef.current;

    const printWindow = window.open("", "_blank");

    printWindow.document.write(`
      <html dir="rtl">
        <head>
          <title>فاتورة</title>

          <style>
            body {
              font-family: Arial, sans-serif;
              padding: 30px;
              color: #272727;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 20px;
            }

            th,
            td {
              border: 1px solid #EEE5E8;
              padding: 10px;
              text-align: center;
            }

            th {
              background: #F9E9EE;
            }

            img {
              max-width: 200px;
            }
          </style>
        </head>

        <body>
          ${content.outerHTML}
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.print();
  };

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          minHeight: "300px",
          color: "#B5183F",
        }}
      >
        <div className="text-center">
          <div
            className="spinner-border mb-3"
            style={{
              color: "#B5183F",
            }}
          />

          <div
            style={{
              color: "#999999",
            }}
          >
            جار التحميل...
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      dir="rtl"
      className="dashboard-orders"
      style={{
        minHeight: "100vh",
        backgroundColor: "#FDFBFC",
        padding: "5px",
        color: "#272727",
      }}
    >
      {/* =========================================
          HEADER
      ========================================= */}

      <div
        className="mb-4"
        style={{
          backgroundColor: "#FFFFFF",
          border: "1px solid #EEE5E8",
          borderRadius: "18px",
          padding: "22px",
          boxShadow: "0 8px 30px rgba(39,39,39,.04)",
        }}
      >
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
          <div>
            <h2
              className="fw-bold mb-1"
              style={{
                color: "#272727",
                fontSize: "24px",
              }}
            >
              قائمة الطلبات
            </h2>

            <p
              className="mb-0"
              style={{
                color: "#999999",
                fontSize: "14px",
              }}
            >
              إدارة ومتابعة جميع طلبات العملاء
            </p>
          </div>

          <div
            className="d-flex align-items-center justify-content-center"
            style={{
              minWidth: "55px",
              height: "55px",
              padding: "0 16px",

              backgroundColor: "#F9E9EE",
              color: "#B5183F",

              borderRadius: "14px",
              fontWeight: "700",
            }}
          >
            <span className="me-2">{orders.length}</span>

            <span>طلب</span>
          </div>
        </div>
      </div>

      {/* =========================================
          FILTERS
      ========================================= */}

      <div
        className="mb-4"
        style={{
          backgroundColor: "#FFFFFF",
          border: "1px solid #EEE5E8",
          borderRadius: "18px",
          padding: "22px",

          boxShadow: "0 8px 30px rgba(39,39,39,.04)",
        }}
      >
        <div className="d-flex align-items-center gap-2 mb-4">
          <div
            className="d-flex align-items-center justify-content-center"
            style={{
              width: "38px",
              height: "38px",
              borderRadius: "10px",
              backgroundColor: "#F9E9EE",
              color: "#B5183F",
            }}
          >
            <i className="fa-solid fa-filter" />
          </div>

          <div>
            <h5
              className="mb-0 fw-bold"
              style={{
                color: "#272727",
              }}
            >
              فلترة الطلبات
            </h5>

            <small
              style={{
                color: "#999999",
              }}
            >
              استخدم الفلاتر للوصول للطلبات المطلوبة
            </small>
          </div>
        </div>

        <div className="row g-3">
          {/* Start Date */}

          <div className="col-xl-3 col-md-6">
            <label
              className="form-label fw-semibold"
              style={{
                color: "#272727",
                fontSize: "13px",
              }}
            >
              تاريخ البداية
            </label>

            <input
              type="date"
              className="form-control dashboard-input"
              name="start_date"
              value={filters.start_date}
              onChange={handleFilterChange}
            />
          </div>

          {/* End Date */}

          <div className="col-xl-3 col-md-6">
            <label
              className="form-label fw-semibold"
              style={{
                color: "#272727",
                fontSize: "13px",
              }}
            >
              تاريخ النهاية
            </label>

            <input
              type="date"
              className="form-control dashboard-input"
              name="end_date"
              value={filters.end_date}
              onChange={handleFilterChange}
            />
          </div>

          {/* Status */}

          <div className="col-xl-3 col-md-6">
            <label
              className="form-label fw-semibold"
              style={{
                color: "#272727",
                fontSize: "13px",
              }}
            >
              الحالة
            </label>

            <select
              className="form-select dashboard-input"
              name="status"
              value={filters.status}
              onChange={handleFilterChange}
            >
              <option value="">الكل</option>

              {Object.entries(statusOptions).map(([value, label]) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </select>
          </div>

          {/* Order Number */}

          <div className="col-xl-3 col-md-6">
            <label
              className="form-label fw-semibold"
              style={{
                color: "#272727",
                fontSize: "13px",
              }}
            >
              رقم الأوردر
            </label>

            <div className="position-relative">
              <i
                className="fa-solid fa-magnifying-glass"
                style={{
                  position: "absolute",
                  right: "14px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#999999",
                  zIndex: 2,
                }}
              />

              <input
                type="text"
                className="form-control dashboard-input"
                placeholder="ابحث برقم الأوردر"
                name="order_number"
                value={filters.order_number}
                onChange={handleFilterChange}
                style={{
                  paddingRight: "40px",
                }}
              />
            </div>
          </div>
        </div>

        {/* Export */}

        <div className="d-flex justify-content-end mt-4">
          <button
            onClick={handleExport}
            className="btn d-flex align-items-center justify-content-center gap-2"
            style={{
              backgroundColor: "#B5183F",
              color: "#FFFFFF",

              border: "none",
              borderRadius: "11px",

              padding: "11px 22px",

              fontWeight: "600",

              boxShadow: "0 6px 18px rgba(181,24,63,.16)",
            }}
          >
            <i className="fa-solid fa-file-export" />
            استخراج الطلبات
          </button>
        </div>
      </div>

      {/* =========================================
          ORDERS TABLE
      ========================================= */}

      <div
        style={{
          backgroundColor: "#FFFFFF",
          border: "1px solid #EEE5E8",
          borderRadius: "18px",
          overflow: "hidden",

          boxShadow: "0 8px 30px rgba(39,39,39,.04)",
        }}
      >
        {/* Table */}

        <div className="table-responsive">
          <table
            className="table mb-0 align-middle text-center"
            style={{
              minWidth: "1100px",
            }}
          >
            <thead>
              <tr
                style={{
                  backgroundColor: "#F9E9EE",
                }}
              >
                <th>رقم الأوردر</th>
                <th>الاسم</th>
                <th>رقم الهاتف</th>
                <th>رقم الواتس</th>
                <th>الإجمالي</th>
                <th>الشحن</th>
                <th>العنوان</th>
                <th>الحالة</th>
                <th>الفاتورة</th>
              </tr>
            </thead>

            <tbody>
              {orders
                .filter((order) =>
                  filters.order_number
                    ? order.order_number
                        .toString()
                        .includes(filters.order_number.toString())
                    : true,
                )
                .map((order) => (
                  <tr
                    key={order.id}
                    className={getStatusClass(order.status)}
                    style={{
                      borderBottom: "1px solid #EEE5E8",
                    }}
                  >
                    <td>
                      <span
                        style={{
                          color: "#B5183F",
                          fontWeight: "700",
                        }}
                      >
                        #{order.order_number}
                      </span>
                    </td>

                    <td
                      style={{
                        fontWeight: "600",
                        color: "#272727",
                      }}
                    >
                      {order.name}
                    </td>

                    <td
                      style={{
                        color: "#555",
                      }}
                    >
                      {order.address?.phone}
                    </td>

                    <td
                      style={{
                        color: "#555",
                      }}
                    >
                      {order.phone}
                    </td>

                    <td>
                      <strong
                        style={{
                          color: "#272727",
                        }}
                      >
                        {order.total_price}
                      </strong>

                      <small
                        style={{
                          color: "#999999",
                          marginRight: "4px",
                        }}
                      >
                        ج.م
                      </small>
                    </td>

                    <td>
                      <span
                        style={{
                          color: "#555",
                        }}
                      >
                        {order.shipping_price}
                      </span>

                      <small
                        style={{
                          color: "#999999",
                          marginRight: "4px",
                        }}
                      >
                        ج.م
                      </small>
                    </td>

                    {/* Address */}

                    <td
                      style={{
                        maxWidth: "250px",
                        minWidth: "180px",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        color: "#555",
                      }}
                      title={order.address?.address || ""}
                    >
                      {order.address?.address
                        ? order.address.address.length > 60
                          ? `${order.address.address.slice(0, 60)}...`
                          : order.address.address
                        : "غير محدد"}
                    </td>

                    {/* Status */}

                    <td>
                      <select
                        className="form-select"
                        value={order.status}
                        onChange={(e) =>
                          handleStatusChange(order.id, e.target.value)
                        }
                        style={{
                          minWidth: "125px",

                          border: "1px solid #EEE5E8",

                          borderRadius: "9px",

                          backgroundColor: "#FDFBFC",

                          color: "#272727",

                          fontSize: "13px",

                          fontWeight: "600",
                        }}
                      >
                        {Object.entries(statusOptions).map(([value, label]) => (
                          <option key={value} value={value}>
                            {label}
                          </option>
                        ))}
                      </select>
                    </td>

                    {/* Invoice */}

                    <td>
                      <button
                        className="btn d-inline-flex align-items-center justify-content-center"
                        onClick={() => setSelectedOrder(order)}
                        title="عرض الفاتورة"
                        style={{
                          width: "40px",
                          height: "40px",

                          borderRadius: "10px",

                          border: "1px solid #F9E9EE",

                          backgroundColor: "#F9E9EE",

                          color: "#B5183F",

                          transition: "all .2s ease",
                        }}
                      >
                        <i className="fas fa-file-invoice" />
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* =========================================
          INVOICE MODAL
      ========================================= */}

      {selectedOrder && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(39,39,39,.65)",
            padding: "15px",
          }}
          tabIndex="-1"
        >
          <div
            className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
            style={{
              maxWidth: "850px",
            }}
          >
            <div
              className="modal-content"
              style={{
                border: "none",
                borderRadius: "20px",
                overflow: "hidden",
              }}
            >
              {/* Modal Header */}

              <div
                className="modal-header"
                style={{
                  backgroundColor: "#B5183F",
                  color: "#FFFFFF",
                  border: "none",
                  padding: "18px 22px",
                }}
              >
                <div>
                  <h5 className="modal-title fw-bold mb-1">
                    فاتورة الطلب #{selectedOrder.order_number}
                  </h5>

                  <small
                    style={{
                      opacity: ".8",
                    }}
                  >
                    تفاصيل الطلب والفاتورة
                  </small>
                </div>

                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setSelectedOrder(null)}
                />
              </div>

              {/* Modal Body */}

              <div
                className="modal-body"
                style={{
                  backgroundColor: "#FDFBFC",
                  padding: "20px",
                }}
              >
                <div
                  ref={invoiceRef}
                  className="p-4"
                  style={{
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #EEE5E8",
                    borderRadius: "16px",
                    color: "#272727",
                  }}
                >
                  {/* Invoice Title */}

                  <div className="text-center mb-4">
                    <img
                      src="/images/nabtah.png"
                      alt="Nabta"
                      style={{
                        width: "150px",
                        maxWidth: "100%",
                        objectFit: "contain",
                      }}
                    />

                    <h3
                      className="fw-bold mt-3 mb-0"
                      style={{
                        color: "#B5183F",
                      }}
                    >
                      فاتورة طلب
                    </h3>
                  </div>

                  {/* Customer Info */}

                  <div className="row g-3 mb-4">
                    <div className="col-md-7">
                      <div
                        className="p-3 h-100"
                        style={{
                          backgroundColor: "#FDFBFC",
                          border: "1px solid #EEE5E8",
                          borderRadius: "12px",
                        }}
                      >
                        <h5
                          className="fw-bold mb-3"
                          style={{
                            color: "#B5183F",
                          }}
                        >
                          معلومات العميل
                        </h5>

                        <p className="mb-2">
                          <strong>الاسم:</strong> {selectedOrder.name}
                        </p>

                        <p className="mb-2">
                          <strong>رقم الهاتف:</strong> {selectedOrder.phone}
                        </p>

                        <p className="mb-2">
                          <strong>رقم الواتس:</strong>{" "}
                          {selectedOrder.address?.phone}
                        </p>

                        <p className="mb-2">
                          <strong>العنوان:</strong>{" "}
                          {selectedOrder.address?.address || "غير محدد"}
                        </p>

                        <p className="mb-0">
                          <strong>رقم الطلب:</strong>{" "}
                          {selectedOrder.order_number}
                        </p>
                      </div>
                    </div>

                    <div className="col-md-5">
                      <div
                        className="p-3 h-100 d-flex align-items-center justify-content-center"
                        style={{
                          backgroundColor: "#F9E9EE",
                          borderRadius: "12px",
                        }}
                      >
                        <img
                          src="/images/nabtah.png"
                          alt="logo"
                          style={{
                            width: "80%",
                            maxWidth: "200px",
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Products */}

                  <div className="table-responsive mb-4">
                    <table className="table table-bordered text-center align-middle mb-0">
                      <thead>
                        <tr
                          style={{
                            backgroundColor: "#F9E9EE",
                          }}
                        >
                          <th>#</th>
                          <th>المنتج</th>
                          <th>الكمية</th>
                          <th>السعر</th>
                          <th>المجموع</th>
                        </tr>
                      </thead>

                      <tbody>
                        {selectedOrder.order_items?.map((item, index) => (
                          <tr key={item.id}>
                            <td>{index + 1}</td>

                            <td
                              style={{
                                fontWeight: "600",
                              }}
                            >
                              {item.product_name || "غير محدد"}
                            </td>

                            <td>{item.quantity}</td>

                            <td>{item.price} ج.م</td>

                            <td
                              style={{
                                fontWeight: "700",
                                color: "#B5183F",
                              }}
                            >
                              {item.price * item.quantity} ج.م
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Totals */}

                  <div className="row justify-content-end">
                    <div className="col-md-6">
                      <table className="table table-bordered mb-0">
                        <tbody>
                          <tr>
                            <th
                              style={{
                                backgroundColor: "#FDFBFC",
                              }}
                            >
                              المجموع الجزئي
                            </th>

                            <td>{selectedOrder.subtotal} ج.م</td>
                          </tr>

                          <tr>
                            <th
                              style={{
                                backgroundColor: "#FDFBFC",
                              }}
                            >
                              سعر الشحن
                            </th>

                            <td>{selectedOrder.shipping_price} ج.م</td>
                          </tr>

                          <tr>
                            <th
                              style={{
                                backgroundColor: "#B5183F",
                                color: "#FFFFFF",
                              }}
                            >
                              الإجمالي
                            </th>

                            <td
                              style={{
                                backgroundColor: "#F9E9EE",
                                color: "#B5183F",
                                fontWeight: "800",
                              }}
                            >
                              {selectedOrder.total_price} ج.م
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              {/* Footer */}

              <div
                className="modal-footer justify-content-center flex-wrap gap-2"
                style={{
                  backgroundColor: "#FFFFFF",
                  borderTop: "1px solid #EEE5E8",
                }}
              >
                <button
                  className="btn"
                  onClick={handleDownloadImage}
                  style={{
                    backgroundColor: "#B5183F",
                    color: "#FFFFFF",
                    borderRadius: "10px",
                    padding: "10px 18px",
                  }}
                >
                  <i className="fas fa-download mx-2" />
                  تحميل كصورة
                </button>

                <button
                  className="btn"
                  onClick={handlePrintInvoice}
                  style={{
                    backgroundColor: "#DEEDE8",
                    color: "#37685A",
                    borderRadius: "10px",
                    padding: "10px 18px",
                  }}
                >
                  <i className="fas fa-print mx-2" />
                  طباعة
                </button>

                <button
                  className="btn"
                  onClick={() => setSelectedOrder(null)}
                  style={{
                    backgroundColor: "#FDFBFC",
                    color: "#666",
                    border: "1px solid #EEE5E8",
                    borderRadius: "10px",
                    padding: "10px 18px",
                  }}
                >
                  <i className="fas fa-times mx-2" />
                  إغلاق
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DashboardOrders;
